import * as types from './mutation-types'
const mutations = {
  [types.SKIN]: (state, payload) => { state.skin = payload },
  [types.TOKEN]: (state, payload) => { state.token = payload },
  [types.MENUOPENNAME]: (state, payload) => { state.menuOpenName = payload },
  [types.MENUACTIVENAME]: (state, payload) => { state.menuActiveName = payload },
  [types.PAGE_SIZE]: (state, payload) => { state.pageSize = payload },
  [types.MODEL_DISABLED]: (state, payload) => { state.modelDisabled = payload },
  [types.CRUMBS_LIST]: (state, payload) => {
    if (Array.isArray(payload)) {
      state.crumbsList = payload
    } else if (Object.prototype.toString.call(payload) === '[object Object]') {
      state.crumbsList.splice(payload.start, payload.count)
    }
  },
  [types.MENU_LIST]: (state, payload) => { state.menuList = payload },
  [types.BIND_PHONE]: (state, payload) => { state.bindPhone = payload }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js